const GA4_ID = 'G-892MCX6JE3';
const FAQ_ROOT = '.faq__wrapper';
const FAQ_ITEM = '.faq__item';
const FAQ_TOGGLE = '.collapsible-toggle';

const script = document.querySelector('script[data-faq-tracking]');
const DEBUG = script?.dataset.debug === 'true';

const opened = new Set();

function send(name, params) {
  if (typeof window.gtag !== 'function') return;
  const payload = {
    ...params,
    send_to: GA4_ID,
    ...(DEBUG && { debug_mode: true }),
  };
  window.gtag('event', name, payload);
  if (DEBUG) console.log('[FAQ]', name, payload);
}

function questionOf(item) {
  return (item.querySelector(FAQ_TOGGLE)?.textContent ?? '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 100);
}

document.addEventListener('openable-element:open', (event) => {
  if (window.Shopify?.designMode) return;

  const panel = event.target;
  const item = panel.closest?.(FAQ_ITEM);
  if (!item?.closest(FAQ_ROOT)) return;

  const question = questionOf(item);
  const key = panel.id || question;
  if (opened.has(key)) return;
  opened.add(key);

  send('faq_open', { faq_question: question });
});

if (DEBUG) {
  console.log('[FAQ] Tracking geladen');
}
